// extracted by mini-css-extract-plugin
export default {"card":"c0-z","carouselContainer":"d0-z","carouselContent":"e0-z"};